var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M27 28h-21a1 1 0 0 0-1 1v33a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-33a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M27 1h-21a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58 44h-21a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58 1h-21a1 1 0 0 0-1 1v33a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-33a1 1 0 0 0-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.17088b9722da24dc85e24cd4f9fbcb21.svg";
export { ForwardRef as ReactComponent };